import axios from 'axios';
import { SALES } from '../constants';

export const getOrientalAccountNumber = async (appId, accessToken) => {
  let result = null;
  try {
    result = await axios.post(
      process.env.REACT_APP_GET_FUNDING_ORIENTAL_URL,
      { ApplicationId: appId },
      {
        headers: {
          appid: 'sales',
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};

export const getPlaidLinkToken = async (accessToken, language) => {
  let result = null;
  let lang = 'en';
  if (language === 'ES') {
    lang = 'es';
  }
  try {
    result = await axios.post(
      process.env.REACT_APP_GET_LINKTOKEN_URL,
      { source: 'DS', language: lang },
      {
        headers: {
          appid: 'sales',
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (error) {
    return error.response;
  }
  return result;
};
export const sendPlaidPublicToken = async (publicToken, uuid, applicationId, accessToken) => {
  let result = null;
  const data = {
    publicToken,
    uuid,
    applicationId,
  };
  try {
    result = await axios.post(process.env.REACT_APP_GET_EXCHANGETOKEN_URL, data, {
      headers: {
        appid: 'sales',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};

export const microDepositVerify = async (data, token) => {
  let result = null;
  try {
    result = await axios.post(process.env.REACT_APP_PLAID_MICRO_VERIFY_LINK_URL, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        appid: SALES,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};

export const microDepositVerifyStatus = async (payload, token) => {
  let result = null;
  try {
    result = await axios.post(process.env.REACT_APP_PLAID_MICRO_VERIFICATION_STATUS, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        appid: SALES,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  } catch (error) {
    return error.response;
  }

  return result;
};
